export function formatPackageDimensionSide(value) {
    if (value == null || value === "") {
        return "0";
    }
    return String(value);
}

export function formatPackageDimensions(pkg) {
    return [
        formatPackageDimensionSide(pkg && pkg.Length),
        formatPackageDimensionSide(pkg && pkg.Width),
        formatPackageDimensionSide(pkg && pkg.Height),
    ].join("x");
}

export function packageWeightLabel(isImperial) {
    return isImperial === false ? "kg" : "lbs";
}

export function formatPackageWeight(weight, weightLabel) {
    const amount = weight == null || weight === "" ? "0" : String(weight);
    return amount + (weightLabel || "");
}

export function formatPackageTypeName(name) {
    return name == null ? "" : String(name);
}

export function resolvePackageTypeName(pkg, customDimensionsLabel) {
    if (pkg && pkg.PackageDefId == 0 && pkg.PackageUri) {
        return customDimensionsLabel;
    }
    return formatPackageTypeName(pkg && pkg.Name);
}

export const UCC128_PACKAGE_GRID_META_NAME = "Ucc128PackageGrid";

export function normalizeUcc128GridConfig(data) {
    if (data == null || data === "") {
        return "";
    }
    if (typeof data === "string") {
        try {
            const parsed = JSON.parse(data);
            if (!parsed || !Array.isArray(parsed.columns)) {
                return "";
            }
            const columns = parsed.columns.filter((column) => column && column.field);
            if (!columns.length) {
                return "";
            }
            if (columns.length !== parsed.columns.length) {
                parsed.columns = columns;
                return JSON.stringify(parsed);
            }
            return data;
        } catch (e) {
            return "";
        }
    }
    if (typeof data === "object" && Array.isArray(data.columns)) {
        const columns = data.columns.filter((column) => column && column.field);
        if (!columns.length) {
            return "";
        }
        return JSON.stringify(Object.assign({}, data, { columns: columns }));
    }
    return "";
}
